export const platTypeList = [
  { label: "今日头条", value: 1, icon: "jrtt" },
  { label: "广点通", value: 2, icon: "gdt" },
  { label: "快手", value: 3, icon: "kuaishou" },
  { label: "今日头条2.0", value: 4, icon: "jrtt" },
  { label: "Google", value: 5, icon: "google" },
  { label: "Facebook", value: 6, icon: "facebook" },
];